import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KetModalEditProductsPropertiesComponent } from './modal-edit-products-properties.component'
import { KetFilemanagerModule } from '../filemanager'
import { FormsModule } from '@angular/forms'
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox'
import { NzButtonModule, NzInputModule, NzInputNumberModule, NzSelectModule } from 'ng-zorro-antd'
import { KetPermissionModule } from '../permission'
import { FroalaEditorModule } from '@cms/libs/froala/ng-editor'
import { SortablejsModule } from 'ngx-sortablejs'

@NgModule({
  declarations: [KetModalEditProductsPropertiesComponent],
  imports: [
    CommonModule,
    KetFilemanagerModule,
    FormsModule,
    NzCheckboxModule,
    NzSelectModule,
    NzInputModule,
    NzInputNumberModule,
    KetPermissionModule,
    FroalaEditorModule,
    SortablejsModule,
    NzButtonModule,
  ],
  exports: [KetModalEditProductsPropertiesComponent],
})
export class KetModalEditProductsPropertiesModule {}
